import type { CSSProperties, ReactNode } from "react";
import { SCREENS } from "@/admin/catalog";
import type { ScreenId } from "@/admin/catalog";

const PAGE: CSSProperties = { display: "flex", flexDirection: "column", gap: 24, padding: 24 };
const TITLE: CSSProperties = { fontFamily: "var(--font-display)", fontSize: 28, margin: 0 };
const SUB: CSSProperties = {
  fontFamily: "var(--font-body)", fontSize: 13, color: "var(--d-fg-muted)", margin: 0,
};

/** Screen title and its one-line Russian description from the catalog. */
export function ScreenFrame({ screen, children }: { screen: ScreenId; children: ReactNode }): JSX.Element {
  const entry = SCREENS.find((s) => s.id === screen);
  return (
    <div style={PAGE} data-testid={`screen-${screen}`}>
      <header style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <h1 style={TITLE}>{entry?.name}</h1>
        <p style={SUB}>{entry?.description}</p>
      </header>
      {children}
    </div>
  );
}
